module.exports = __webpack_public_path__ + "static/img/iCloudDrive.1dffb09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/iCloudDrive.svg
// module id = wb5z
// module chunks = 2